import * as marietta from '../..';
import { ItemLayer } from '.';

export default class RoomTextLayer extends ItemLayer {
  childList: marietta.webcad.item.MonicaObject[] & marietta.webcad.item.parts.RoomText[];

  /**
     * アイテムパーツ作成
     */
  addParts(item) {
    this.spt.addChild(item.spt);

    // アイテム一覧に追加
    this.childList.push(item);
  }

  // アイテムを削除
  deleteItem(item: marietta.webcad.item.parts.RoomText) {
    let target:marietta.webcad.item.parts.RoomText;
    for (let i: number = this.childList.length - 1; i >= 0; i -= 1) {
      target = this.childList[i] as marietta.webcad.item.parts.RoomText;
      if (target === item) {
        this.childList.splice(i, 1);
        break;
      }
    }
  }

  /**
     * 全てのアイテムの移動
     * @moveX Number X軸移動距離
     * @moveY Number Y軸移動距離
     * */
  moveAllItems(moveX: number, moveY: number): void {
    let target: marietta.webcad.item.parts.RoomText;
    for (let i: number = 0; i < this.childList.length; i += 1) {
      target = this.childList[i] as marietta.webcad.item.parts.RoomText;
      target.move(target.x + moveX, target.y + moveY);
    }
  }
}
